module.exports = __webpack_public_path__ + "static/i1-dfd8c8a920279efe94c2f09f792e5370.png";